import './App.css';
import Shortcut from './components/Shortcut';
import Space from './components/Space';
import Taskbar from './components/Taskbar';
import WindowDimensions from './hooks/WindowDimensions';
import { useEffect, useState } from 'react';
import Recycle from './images/RecycleBinEmpty.png';
import Internet from './images/InternetExplorer6.png';
import Explorer from './images/Explorer.png';
import MyComputer from './images/MyComputer.png';
import Window from './components/Window';
import Start from './components/Start';
import MyDocuments from './images/MyDocuments.png';
import MyPictures from './images/MyPictures.png';
import MyMusic from './images/MyMusic.png';
import MinesweeperIcon from './images/Minesweeper.png';
import Minesweeper from './components/Minesweeper';

function App() {
  const { height, width } = WindowDimensions();

  // Laptop only check
  const isLaptop = width >= 1080 && height >= 690;

  const [lines, setLines] = useState(0);
  const [columns, setColumns] = useState(0);

  const [draggingId, setDraggingId] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [toggleStart, setToggleStart] = useState(false);

  // SHUTDOWN STATES
  const [shuttingDown, setShuttingDown] = useState(false);
  const [poweredOff, setPoweredOff] = useState(false);
  const [booting, setBooting] = useState(false);

  // APP CONTENTS
  const appContents = {
    "Recycle Bin": (
      <div>
        <h2>Welcome!</h2>
        <p>
          Hi, I am <strong>Spyros Flouris</strong>, a final-year Computer Science student specializing in
          web development and application security.
        </p>
        <p>
          I build secure, scalable applications using <strong>React.js, Node.js, Express, MySQL/Sequelize, Axios</strong>,
          and I also develop custom WordPress plugins and Elementor functionality.
        </p>
        <p>
          Interests: Boxing, Calisthenics, Ethical Hacking (HackTheBox), Coding
        </p>
      </div>
    ),
    "Internet": (
      <div>
        <h2>My Official Website</h2>
        <p>
          You can visit my official website here:<br />
          <a href="https://cytechsharp.com.cy" target="_blank" rel="noreferrer">
            https://cytechsharp.com.cy
          </a>
        </p>
        <p>From there you can contact me directly.</p>
      </div>
    ),
    "Explorer": (
      <div>
        <h2>Other Projects</h2>
        <ul>
          <li><a href="https://c0smicwebsite.web.app" target="_blank" rel="noreferrer">C0smic Website</a></li>
          <li><a href="https://matcha-commerce.web.app" target="_blank" rel="noreferrer">Matcha Commerce</a></li>
          <li><a href="https://spyrosflouris-portfolio.web.app" target="_blank" rel="noreferrer">Spyros Flouris Portfolio</a></li>
        </ul>
      </div>
    ),
    "My Computer": (
      <div>
        <h2>Contact Me</h2>
        <p>You can reach me at:</p>
        <strong>sharpdevelopment@gmail.com</strong>
        <br />
        <strong>+357 97457785</strong>
      </div>
    ),
      "My Documents": (
    <div>
      <h2>My Documents</h2>

      <h3>Education</h3>
      <ul>
        <li>Final-year Computer Science student — Ionian University</li>
        <li>High School Graduate (Kykkos B High School)</li>
        <li>IGCSE in English</li>
      </ul>

      <h3>Skills</h3>
      <ul>
        <li>React.js, Node.js, Express, Axios</li>
        <li>WordPress & Elementor (custom plugins, shortcodes)</li>
        <li>MySQL / Sequelize</li>
        <li>Ethical hacking (HackTheBox — beginner/intermediate)</li>
        <li>Soft skills: Teamwork, communication, fast learner</li>
      </ul>

      <h3>Experience</h3>
      <ul>
        <li>
          <strong>Web Developer — dots</strong><br />
          One year of WordPress/Elementor development, plugin creation, JS/PHP, SEO improvements.
        </li>
        <li><strong>Customer Service — Pahit Ice</strong></li>
        <li><strong>Barista — Zorpas</strong></li>
      </ul>

      <h3>Interests</h3>
      <ul>
        <li>Boxing</li>
        <li>Calisthenics</li>
        <li>Coding</li>
        <li>Ethical hacking (HackTheBox training)</li>
      </ul>
    </div>
  ),

    "Minesweeper": <Minesweeper />
  };

  // SHUTDOWN FUNCTIONS
  const shutdownComputer = () => {
    if (shuttingDown || poweredOff) return;

    setShuttingDown(true);
    new Audio(require('./sounds/xp-shutdown.mp3')).play();

    setWindows([]);

    setTimeout(() => {
      setShuttingDown(false);
      setPoweredOff(true);
    }, 4000);
  };

  const powerOn = () => {
    if (!poweredOff) return;

    setBooting(true);
    setPoweredOff(false);
    new Audio(require('./sounds/xp-startup.mp3')).play();

    setTimeout(() => {
      setBooting(false);
    }, 4000);
  };

  const handleToggleStart = () => {
    setToggleStart(prev => !prev);
  };

  // WINDOWS MANAGEMENT
  const [windows, setWindows] = useState([]);
  const [zCounter, setZCounter] = useState(1);

  const [shortcutData, setShortcutData] = useState([
    { id: 0, label: "Recycle Bin", image: Recycle, position: 0 },
    { id: 1, label: "Internet", image: Internet, position: 1 },
    { id: 2, label: "Explorer", image: Explorer, position: 2 },
    { id: 3, label: "My Computer", image: MyComputer, position: 3 },
    { id: 10, label: "My Documents", image: MyDocuments },
    { id: 11, label: "My Pictures", image: MyPictures },
    { id: 12, label: "My Music", image: MyMusic },
    { id: 13, label: "Minesweeper", image: MinesweeperIcon },
  ]);

  // Update desktop grid
  useEffect(() => {
    const newLines = Math.floor(width / 100);
    const newColumns = Math.floor((height - 300) / 100);
    setLines(newLines);
    setColumns(newColumns);
  }, [width, height]);

useEffect(() => {
  const closeStartMenu = (e) => {
    if (!toggleStart) return;

    // If click is inside Start menu → ignore
    if (e.target.closest(".start-menu")) return;

    // If click is on Start button → ignore
    if (e.target.closest(".taskbar-start-button")) return;

    // Close menu
    setToggleStart(false);
  };

  document.addEventListener("mousedown", closeStartMenu);

  return () => document.removeEventListener("mousedown", closeStartMenu);
}, [toggleStart]);


  const handleDragStart = (e, id) => {
    setDraggingId(id);
    setIsDragging(true);
  };
  const handleDragEnd = () => setIsDragging(false);

  const openWindow = (shortcutId) => {
    if (!isDragging) {
      const appData = shortcutData.find(s => s.id === shortcutId);
      if (!appData) return;

      const alreadyOpen = windows.some(w => w.title === appData.label);
      if (alreadyOpen) {
        setWindows(prev =>
          prev.map(w =>
            w.title === appData.label
              ? { ...w, zIndex: zCounter }
              : w
          )
        );
        setZCounter(z => z + 1);
        return;
      }

      setWindows(prev => [
        ...prev,
        {
          id: Date.now(),
          title: appData.label,
          icon: appData.image,
          content: appContents[appData.label],
          minimized: false,
          maximized: false,
          zIndex: zCounter
        }
      ]);

      setZCounter(z => z + 1);
    }
  };

  const minimizeWindow = (id) => {
    setWindows(prev =>
      prev.map(w =>
        w.id === id ? { ...w, minimized: true } : w
      )
    );
  };

  const closeWindow = (id) => {
    setWindows(prev => prev.filter(w => w.id !== id));
  };

  const toggleMaximize = (id) => {
    setWindows(prev =>
      prev.map(w =>
        w.id === id ? { ...w, maximized: !w.maximized } : w
      )
    );
  };

  const restoreWindow = (id) => {
    setWindows(prev =>
      prev.map(w =>
        w.id === id
          ? { ...w, minimized: false, zIndex: zCounter }
          : w
      )
    );
    setZCounter(z => z + 1);
  };

  const bringToFront = (id) => {
    setWindows(prev =>
      prev.map(w =>
        w.id === id ? { ...w, zIndex: zCounter } : w
      )
    );
    setZCounter(z => z + 1);
  };

  const handleDrop = (e, dropIndex) => {
    const occupied = shortcutData.some(s => s.position === dropIndex);
    if (occupied) return;

    setShortcutData(prev =>
      prev.map(s =>
        s.id === draggingId ? { ...s, position: dropIndex } : s
      )
    );
    setDraggingId(null);
    setIsDragging(false);
  };

  useEffect(() => {
    const handler = () => shutdownComputer();
    window.addEventListener("shutdown", handler);
    return () => window.removeEventListener("shutdown", handler);
  }, []);

  if (!isLaptop) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontFamily: "Tahoma, sans-serif",
          backgroundColor: "#c0c0c0",
          color: "#000080",
          padding: "20px"
        }}
      >
        <div>
          <h1>Screen Too Small</h1>
          <p>This website is designed for laptop screens (1080px width and 690px height).</p>
          <p>Please use a device with a larger screen to access it.</p>
        </div>
      </div>
    );
  }

  if (!lines || !columns) return null;

  return (
    <div className="App">

      {/* SHUTTING DOWN SCREEN */}
      {shuttingDown && (
        <div className="shutdown-screen">
          <div className="shutdown-content">
            <img src={require('./images/flower.jpg')} className="shutdown-image" />
            <h2>User</h2>
            <p>Shutting down…</p>
          </div>
        </div>
      )}

      {/* POWERED OFF — BLACK SCREEN + BUTTON */}
      {poweredOff && (
        <div className="poweroff-screen">
          <button className="power-button" onClick={powerOn}>
            <img src={require('./images/Standby.png')} />
          </button>
        </div>
      )}

      {/* BOOTING / STARTUP SCREEN */}
      {booting && (
        <div className="startup-screen">
          <h1>Windows XP</h1>
          <p>Starting up…</p>
        </div>
      )}

      {toggleStart && <Start openWindow={openWindow} shortcuts={shortcutData} />}

      {/* Desktop Grid */}
      {Array.from({ length: lines * columns }, (_, index) => {
        const shortcut = shortcutData.find(s => s.position === index);
        return (
          <Space
            key={index}
            id={index}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, index)}
            prop={
              shortcut ? (
                <Shortcut
                  label={shortcut.label}
                  style={{
                    backgroundImage: `url(${shortcut.image})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }}
                  draggable
                  onDragStart={(e) => handleDragStart(e, shortcut.id)}
                  onDragEnd={handleDragEnd}
                  onDoubleClick={() => openWindow(shortcut.id)}
                />
              ) : null
            }
          />
        );
      })}

      {/* Render all windows */}
      {windows.map(win =>
        !win.minimized && (
          <Window
            key={win.id}
            win={win}
            onClose={() => closeWindow(win.id)}
            onMinimize={() => minimizeWindow(win.id)}
            onToggleMaximize={() => toggleMaximize(win.id)}
            bringToFront={() => bringToFront(win.id)}
          />
        )
      )}

      <Taskbar windows={windows} onRestore={restoreWindow} toggleStart={toggleStart} onToggleStart={handleToggleStart} />
    </div>
  );
}

export default App;
